import { useState, useEffect } from "react";
import axios from "axios";

const useAuth = () => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const urlApi = "https://analyse-feed-holub.onrender.com";

  useEffect(() => {
    const token = localStorage.getItem("feedToken");
    if (token) {
      verifyToken(token);
    }
  }, []);

  const verifyToken = async (token: string) => {
    try {
      const response = await axios.post(urlApi + "/api/verify-token", {
        token,
      });
      if (response.data.valid) {
        setIsAuthorized(true);
      } else {
        localStorage.removeItem("feedToken");
        setError(null);
      }
    } catch {
      setError("Nastala chyba při ověřování tokenu.");
    }
  };

  const login = async (password: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(urlApi + "/api/verify-password", {
        password,
      });

      if (response.data.success) {
        setIsAuthorized(true);
        localStorage.setItem("feedToken", response.data.token);
      } else {
        setError("Nesprávné heslo, zkus to znovu.");
      }
    } catch {
      setError("Nastala chyba při ověřování hesla.");
    } finally {
      setLoading(false);
    }
  };

  return { isAuthorized, loading, error, login };
};

export default useAuth;
